import { CmsProduct, CmsVirtualProduct } from '../../../types/cms_shared_types';

export type OrderedDisplayItem =
  | {
      type: 'product';
      product: CmsProduct;
      isExtraProduct: boolean;
    }
  | {
      type: 'virtual';
      virtualProduct: CmsVirtualProduct;
    };

type SortableOrderedDisplayItem = OrderedDisplayItem & {
  bucketPriority: number;
  order: number;
  originalIndex: number;
};

export const getOrderedDisplayItems = ({
  products,
  virtualProducts,
  extraProducts,
}: {
  products: CmsProduct[];
  virtualProducts: CmsVirtualProduct[];
  extraProducts: CmsProduct[];
}): OrderedDisplayItem[] => {
  const extraProductCodes = new Set(extraProducts.map((product) => product.code));

  const sortableItems: SortableOrderedDisplayItem[] = [
    ...products.map((product, index) => ({
      type: 'product' as const,
      product,
      isExtraProduct: extraProductCodes.has(product.code),
      bucketPriority: extraProductCodes.has(product.code) ? 1 : 0,
      order: product.order,
      originalIndex: index,
    })),
    ...virtualProducts.map((virtualProduct, index) => ({
      type: 'virtual' as const,
      virtualProduct,
      bucketPriority: 0,
      order: virtualProduct.order,
      originalIndex: products.length + index,
    })),
  ];

  sortableItems.sort((left, right) => {
    if (left.bucketPriority !== right.bucketPriority) {
      return left.bucketPriority - right.bucketPriority;
    }

    if (left.order !== right.order) {
      return left.order - right.order;
    }

    return left.originalIndex - right.originalIndex;
  });

  return sortableItems.map((item): OrderedDisplayItem => {
    if (item.type === 'product') {
      return { type: 'product', product: item.product, isExtraProduct: item.isExtraProduct };
    }
    return { type: 'virtual', virtualProduct: item.virtualProduct };
  });
};
